var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UniversalSelectInput',_vm._g(_vm._b({attrs:{"value":_vm.value,"filterable":"","remote":"","loading":_vm.fetching,"remote-method":_vm.onSearch,"options":_vm.items},on:{"clear":function($event){return _vm.onSearch('')}}},'UniversalSelectInput',Object.assign({}, {clearable: true,
    getOptionKey: function (item) { return item.id; },
    getOptionLabel: function (item) { return item.str; }},
    _vm.$attrs),false),Object.assign({}, _vm.$listeners, {input: _vm.onInput})))}
var staticRenderFns = []

export { render, staticRenderFns }